module.exports = __webpack_public_path__ + "static/media/Frame.52e114db.svg";